module.exports = __webpack_public_path__ + "static/media/N1_Dash.032ae21a.png";